import * as React from 'react';

import { ICaseAssertionModel } from '../../../interfaces/ICase';
import { IValidation } from '../../../interfaces/IError';
import { Modal } from 'react-bootstrap';

export interface ICaseNarrativeModalProps {
    assertion: ICaseAssertionModel;
    title: string;
    validation: IValidation;
    onSubmit: (narrativeValue: string) => void;
    onCancel: () => void;
}

export function CaseNarrativeModal(props: ICaseNarrativeModalProps) {
    const [narrativeValue, setNarrativeValue] = React.useState<string>(
        props.assertion?.textValue ?? ''
    );
    const textareaRef = React.useRef<HTMLTextAreaElement | null>(null);

    const handleTextAreaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNarrativeValue(e.target.value);
    };

    const handleOkClick = () => {
        props.onSubmit(narrativeValue);
    };

    const handleClearClick = () => {
        setNarrativeValue('');
        textareaRef.current?.focus();
    };

    const handleCancelClick = () => {
        props.onCancel();
    };

    if (!props.assertion) return null;

    return (
        <Modal centered show backdrop>
            <Modal.Header>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <span className="text-danger">{props.validation.model}</span>
                </div>
                <div>
                    <textarea
                        className="form-control"
                        value={narrativeValue}
                        name={props.assertion?.assertionDescriptorGuid}
                        rows={10}
                        onChange={handleTextAreaChange}
                        ref={textareaRef}
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-default" onClick={handleClearClick}>
                    Clear
                </button>
                <button className="btn btn-default" onClick={handleCancelClick}>
                    Cancel
                </button>
                <button className="btn btn-black" onClick={handleOkClick}>
                    OK
                </button>
            </Modal.Footer>
        </Modal>
    );
}
